import { useEffect, useState } from "react";
import { IndexFilterObject, OptionFilterObject, ResultFilterObject, ShopMetafields } from "~/types";
import ProductsHeader from "./ProductHeader.client";
import axios from "axios";
import ProductListHeader from "./ProductListHeader.client";
import ProductListGrid from "./ProductListGrid.client";
import FilterModal from "./FilterModal.client";
import { retailSystem, storeCredentials } from "../../../setup/settings/index";
import InfiniteScroll from "react-infinite-scroll-component";
import BackToTopButton from "../elements/BackToTop.client";
import { buttonBackToTop } from "../../../setup/settings/__product";

type Props = {
    title: string,
    descriptionCategory: string,
    options: OptionFilterObject,
    currency: string,
    search: string,
    brand: string,
    category: string,
    productRange: string,
    shop: any
}

export default function ProductList({ title, descriptionCategory, options, currency, search, brand, category, productRange, shop }: Props) {

    const [change, setChange] = useState(true);
    const [sortValue, setSortValue] = useState<{ label: string; field: string; } | undefined>();
    const [showFilter, setShowFilter] = useState(false);
    const [response, setResponse] = useState<ResultFilterObject>();
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<IndexFilterObject[]>([]);
    const [loadProducts, setLoadProducts] = useState(false);
    const [finished, setFinished] = useState<boolean>(false);
    const [filters, setFilters] = useState<ResultFilterObject>();
    const [firstLoading, setFirstLoading] = useState<boolean>(true);
    const [update, setUpdate] = useState<boolean>(false);
    const [showMore, setShowMore] = useState<boolean>(false);
    const [scrolling, setScrolling] = useState<boolean>(false);


    const shopSettings = shop?.settings?.value != null ? JSON.parse(shop.settings.value) : null;
    const disableInfiniteScroll: boolean = shopSettings?.disableInfiniteScroll != undefined ? shopSettings.disableInfiniteScroll : false;

    const defaultFilter = {
        pagination: {
            page: 1,
            limit: 24
        },
        options: [],
        search,
        brand_handler: brand,
        category,
        product_range_handler: productRange,
        price_range: {
            low: options.low,
            high: options.high
        },
        sort: []
    };

    const closeFilter = () => {
        setShowFilter(false);
    }

    const clearFilter = () => {

        let defaultSort = options.sort_options.find(so => so.field == options.default_sort);
        if (defaultSort == undefined) defaultSort = options.sort_options[0];

        const values: string[] = defaultSort?.field.split('-') ?? []
        let clear = { 
            ...defaultFilter, 
            sort: [{ field: values[0], order: values[1] }],
        }

        setSortValue(defaultSort);
        editURL(clear);
        setChange(true);
    }

    const getFilter = () => {
        const urlLocation = window.location.search;
        const params = new URLSearchParams(urlLocation);
        const appliedFilter = params.getAll('filter');
        const page = params.getAll('page');
        const limit = params.getAll('limit');

        let filter = appliedFilter[0];
        if (filter) filter = decodeURIComponent(filter.replace(/\+/g, " "));
        if (filter) filter = JSON.parse(filter);

        searchParams(params, filter, limit, page);

        if (!filter) {
            filter = defaultFilter;
            let defaultSort = options.sort_options.find(so => so.field == options.default_sort);
            if (defaultSort == undefined) defaultSort = options.sort_options[0];

            const values: string[] = defaultSort?.field.split('-') ?? [];
            values[0] = values[0].includes("price") ? "fromPrice" : values[0];

            filter = { ...filter, sort: [{ field: values[0], order: values[1] }] }
            setSortValue(defaultSort);
            setFirstLoading(true)
        }
        else {
            if (!sortValue) {

                filter.pagination.page = 1;
                let sort = filter.sort[0];
                if (sort.field.includes('Price')) sort.field = 'price';
                let resort = { ...filter.sort[0] };
                if (resort.field.includes('price')) resort.field = 'fromPrice';
                const sorted = options.sort_options.find(so => so.field == `${sort.field}-${sort.order}`)
                if (sort.field === "") setSortValue({ field: "", label: "Relevance" });
                else setSortValue(sorted);
                filter.sort = [resort];
            }
        }

        return filter;
    }

    const editURL = (filter: any) => {

        let copyFilterUrl = Object.assign({}, filter);
        const urlLocation = window.location;
        const url = new URL(urlLocation);

        editFilter(url, copyFilterUrl);

        const filterPath = encodeURIComponent(JSON.stringify(copyFilterUrl));

        url.searchParams.set('filter', filterPath);
        const newUrl = url.href;

        if (firstLoading) {
            window.history.replaceState(null, null, window.location.href);
        }
        window.history.replaceState({ path: newUrl }, '', newUrl)
    }

    const fetchProducts = async (data: any) => {
        setScrolling(true);
        // document.body.style.overflow = "hidden";
        const filter = { ...data }
        try {
            const result = await axios.request({
                url: `${retailSystem.filterUrl}/product`,
                method: 'POST',
                headers: { store: storeCredentials.storeDomain },
                data: filter
            })
            setResponse(result.data);
        } catch (error) {
            console.log('ERROR: ', error);
        } finally {
            setScrolling(false);
            // document.body.style.overflow = "scroll";
        }
    }



    useEffect(() => {
        if (loadProducts && showMore) {
            updateProducts();
        }
    }, [loadProducts]);



    useEffect(() => {

        if (change) {
            setChange(false);
            if (update) {
                fetchProducts(filters);
                setUpdate(false);
            } else {
                let filter = getFilter();
                setFilters(filter)
                fetchProducts(filter);
            }

        }
    }, [change])


    const updateProducts = () => {

        if (filters == undefined) {
            const filter = getFilter();

            const newFilter = {
                ...filter,
                pagination: {
                    ...filter.pagination,
                    page: filter.pagination.page + 1
                }
            };
            setFilters(newFilter)
            setChange(true);
            setUpdate(true);
        }
        else {
            const newFilter = {
                ...filters,
                pagination: {
                    ...filters.pagination,
                    page: filters.pagination.page + 1
                }
            };
            setFilters(newFilter)
            setChange(true);
            setUpdate(true);
        }
    };

    useEffect(() => {
        if (response) {
            if (response.result.result.length == 0) setFinished(true)

            if (filters.pagination?.page == 1) {
                setProducts(response?.result.result);

                if (response.total > filters.pagination?.limit)
                    setShowMore(true)

                if (response.total <= filters.pagination?.limit) {
                    setShowMore(false)
                }
            }
            else {
                let pp = [...products];
                const res = response?.result.result;
                if (res) {
                    pp = pp.concat(res);
                    if (pp?.length < response?.total)
                        setShowMore(true)
                    else {
                        setShowMore(false)
                    }
                }

                setProducts(pp);
            }
            editURL(filters);
        }
    }, [response])


    useEffect(() => {
        if (loading && response) {
            // document.body.style.overflow = "scroll";
            setLoading(false);
        }
    }, [products])

    const editFilter = (url: URL, copyFilterUrl: any) => {
        url.searchParams.set('page', copyFilterUrl.pagination.page);
        url.searchParams.set('limit', copyFilterUrl.pagination.limit);

        url.searchParams.set('brd', encodeURIComponent(copyFilterUrl.brand_handler));
        url.searchParams.set('cat', encodeURIComponent(copyFilterUrl.category));
        url.searchParams.set('pr', encodeURIComponent(copyFilterUrl.product_range_handler));

        delete copyFilterUrl.pagination;
        delete copyFilterUrl.brand_handler;
        delete copyFilterUrl.category;
        delete copyFilterUrl.product_range_handler;
    }
    const searchParams = (params: URLSearchParams, filter: string, limit: string[], page: string[]) => {
        const brand_handler = params.getAll('brd');
        const category = params.getAll('cat');
        const product_range_handler = params.getAll('pr');

        if (filter && limit) {
            filter.pagination = {
                limit: parseInt(limit[0]),
                page: parseInt(page[0])
            };
        }

        if (filter && brand_handler) {
            filter.brand_handler = decodeURIComponent(brand_handler[0].replace(/\+/g, " "));
        }
        if (filter && category) {
            filter.category = decodeURIComponent(category[0].replace(/\+/g, " "));
        }
        if (filter && product_range_handler) {
            filter.product_range_handler = decodeURIComponent(product_range_handler[0].replace(/\+/g, " "));
        }
    }

    useEffect(() => {
        if (disableInfiniteScroll == false) {
            let footer = document.getElementById('footer');

            if (footer != null) {
                footer.style.display = showMore ? 'none' : 'block';
            } else {
                console.error("The id of the div that contains the footer is missing custom footer.");
            }
        }
    }, [showMore])

    return (
        <>
            <ProductsHeader
                title={title}
                productsTotal={response?.total}
                productsPage={products.length}
                descriptionCategory={descriptionCategory}
                loading={loading}
            />

            <div id="ProductList" className="ProductList">
                <div className="ProductList__container">

                    <ProductListHeader
                        sortOptions={options.sort_options}
                        sortValue={sortValue}
                        setSortValue={setSortValue}
                        setChange={setChange}
                        editURL={editURL}
                        getFilter={getFilter}
                        showFilter={showFilter}
                        setShowFilter={setShowFilter}
                        noProducts={!loading && products?.length == 0 && response}
                        loading={loading}
                    />

                    {!loading && products?.length == 0 && response &&
                        <div className="text-center w-full">
                            <h1 className="font-black text-2xl">NO PRODUCTS WERE FOUND</h1>
                            <p className="font-light">No items matched your search</p>
                            <p className="font-light">Check your spelling or search again with less specific terms.</p>
                        </div>
                    }
                    {disableInfiniteScroll ? <>
                        <ProductListGrid getFilter={getFilter} products={products} showFilter={showFilter} loading={loading} scrolling={scrolling} shopSettings={shopSettings} currency={currency}>
                            <FilterModal
                                currency={currency}
                                clearFilter={clearFilter}
                                show={showFilter}
                                close={closeFilter}
                                options={response?.options_filters?.options}
                                price={[options.low, options.high]}
                                getFilter={getFilter}
                                editURL={editURL}
                                setChange={setChange}
                                shop={shop}
                            />
                        </ProductListGrid>
                        {disableInfiniteScroll && showMore &&
                            <div className="div-button-show-more-products" >
                                <button className="button-show-more-products" onClick={updateProducts}>
                                    Show More
                                </button>
                            </div>
                        }
                    </>
                        :
                        <InfiniteScroll
                            dataLength={products.length}
                            next={updateProducts}
                            hasMore={showMore}
                            loader={
                                <div className="flex items-center justify-center mt-6">
                                    <div className="loader"></div>
                                </div>
                            }>
                            <ProductListGrid getFilter={getFilter} products={products} showFilter={showFilter} loading={loading} scrolling={scrolling} shopSettings={shopSettings} currency={currency}>
                                <FilterModal
                                    currency={currency}
                                    clearFilter={clearFilter}
                                    show={showFilter}
                                    close={closeFilter}
                                    options={response?.options_filters?.options}
                                    price={[options.low, options.high]}
                                    getFilter={getFilter}
                                    editURL={editURL}
                                    setChange={setChange}
                                    shop={shop}

                                />
                            </ProductListGrid>
                            {disableInfiniteScroll && showMore &&
                                <div className="div-button-show-more-products" >
                                    <button className="button-show-more-products" onClick={updateProducts}>
                                        Show More
                                    </button>
                                </div>
                            }
                        </InfiniteScroll>
                    }

                    {buttonBackToTop.productListEnabled && <BackToTopButton />}

                </div>
            </div>
        </>
    )
}



